module.exports = __webpack_public_path__ + "img/imgZXGH(12).5ffbafc5.png";